module.exports = __webpack_public_path__ + "img/5d8a4a2efe0b964a8c7fa12ec3ca2b6f.png";